import useHelpers from 'hooks/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { fundCentreActions } from '@/store/fundCentre';
import { useI18n } from 'next-localization';
import { useRouter } from 'next/router';
import { getSelectedTab } from '@/store/fundCentre/selectors';
import React, { useEffect } from 'react';
import styles from '../../styles/TableSelector.module.scss';

type Tab = {
  key: string;
  title: string;
};
type Props = {
  allFundsTabTabs: Tab[];
};

const TableSelector = ({ allFundsTabTabs }: Props) => {
  const { t } = useI18n();
  const router = useRouter();
  const { updateUrlParams } = useHelpers();
  const dispatch = useDispatch();
  const selectedTab = useSelector(getSelectedTab);

  useEffect(() => {
    const tableParam = router.query.table as string;
    if (tableParam) {
      dispatch(fundCentreActions.setSelectedTab(tableParam));
    }
  }, [dispatch, router.query.table]);

  const tabHandler = (tabKey: string) => {
    dispatch(fundCentreActions.setSelectedTab(tabKey));
    updateUrlParams([{ name: 'table', value: tabKey }]);
  };

  return (
    <div className={styles['table-selector']}>
      {allFundsTabTabs.map((tab) => (
        <button
          key={tab.key}
          aria-label={t(tab.key)}
          type="button"
          className={`h4 btn btn-naked pb-3 ${styles.button} ${
            selectedTab === tab.key ? styles.active : ''
          }`}
          onClick={() => tabHandler(tab.key)}
        >
          {t(tab.title)}
        </button>
      ))}
    </div>
  );
};

export default TableSelector;
